<template>

        <tr>
            <td class="id">
                <div class="id font-normal">{{ item.id }}</div>
            </td>
            <td>
                <div class="top font-normal">{{ item.name | maxLength }}</div>
                <div class="bottom font-small">{{ item.performer }}</div>
            </td>
            <td class="right">
                <div class="top font-normal">{{ item.promoter }}% Beteiligung</div>
                <div class="bottom font-small">ab CHF {{ item.price.toLocaleString() }}</div>
            </td>
        </tr>

</template>

<script>
export default {
  props: ['item']
}
</script>
